/**
 * @desc 错误组件
 * @author berlin
 */
import React from 'react'

type Props = {
  children?: React.ReactNode
}
type State = {
  error?: Error
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { error: undefined }
  }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  render() {
    const { error } = this.state
    if (error) {
      return (
        <div
          className='ex-error-boundary'
          style={{ maxHeight: '480px', overflow: 'auto' }}
        >
          <strong>{`${error.message}`}</strong>
          <pre>{`${error.stack}`}</pre>
        </div>
      )
    }
    return this.props.children
  }
}
